module.exports = __webpack_public_path__ + "img/mlb_logo.636ec413.svg";